import { Outlet } from "react-router-dom";
import Header from "../../../components/Header";
import SideMenu from "../../../components/SideMenu/SideMenu";
import classes from "./RootLayout.module.css";

const RootLayout = () => {
  return (
    <>
      <Header />
      <div className="container-fluid">
        <div className="row">
          <div className={`col-12 col-md-2 ${classes["left-navigation"]}`}>
            <SideMenu />
          </div>
          <div className={`col-12 col-md-10 ${classes.contentWrapper}`}>
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default RootLayout;
